import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setModalImage as setModalImageAction } from '../../store/actions';
import { fireGTM } from '../../gtm/gtmUtil';

const InformationIcon = ({
  color,
  gtmObj,
  section,
  text,
  component,
  parentOnClickHandler,
  setModalImage,
  modalImage,
  ariaLabel = '',
  tabIndex,
}) => {
  const { t } = useTranslation();
  const handleInfoIconClickedGTMAndSetImage = (e) => {
    setModalImage(modalImage);

    if (parentOnClickHandler) {
      parentOnClickHandler(e);
    }

    const tempGTMObj = gtmObj;

    if (component) {
      tempGTMObj.component = component;
    }

    fireGTM(tempGTMObj, text, section);
  };

  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="18px"
      height="18px"
      viewBox="0 0 1000 1000"
      onClick={(e) => handleInfoIconClickedGTMAndSetImage(e)}
      onKeyDown={(e) => {
        if (['Enter'].includes(e.key)) handleInfoIconClickedGTMAndSetImage(e);
        if (['Escape'].includes(e.key)) {
          if (parentOnClickHandler) {
            parentOnClickHandler(e);
          }
        }
      }}
      tabIndex={tabIndex || 0}
      aria-label={ariaLabel}
      role="img"
    >
      <title>{t('Information Icon')}</title>

      <g>
        <path
          fill={color}
          d="M500.07,0.14c-276.14,0-500,223.86-500,500s223.86,500,500,500s500-223.86,500-500
            S776.21,0.14,500.07,0.14z M500.07,221.92c46.76,0,84.67,37.91,84.67,84.67s-37.91,84.67-84.67,84.67
            c-46.76,0-84.67-37.91-84.67-84.67v0l0,0C415.4,259.83,453.31,221.92,500.07,221.92z M613.02,734.03
            c0,13.38-10.84,24.22-24.22,24.22H411.18c-13.38,0-24.22-10.84-24.22-24.22v-48.39c-0.09-13.38,10.68-24.3,24.05-24.39
            c0.06,0,0.11,0,0.17,0h24.22v-129h-24.22c-13.38,0-24.22-10.84-24.22-24.22v-48.22c0-13.38,10.84-24.22,24.22-24.22l0,0h129.33
            c13.38,0,24.22,10.84,24.22,24.22l0,0v201.44h24.22c13.38,0,24.22,10.84,24.22,24.22L613.02,734.03z"
        />
      </g>
    </svg>
  );
};

InformationIcon.propTypes = {
  color: PropTypes.string.isRequired,
};

export default connect(null, { setModalImage: setModalImageAction })(
  InformationIcon
);
